<div class="container-fluid w-100 bg-pink">
    <div class="container pt-5 py-lg-5">
        <div class="row py-lg-5 g-lg-5 flex-column-reverse flex-lg-row">
            <div class="col-lg-6 d-flex text-center text-lg-start align-items-center">
                <div class="px-2 pt-4">
                    <h1 class="fw-bolder ">
                            <span class="font-56 d-lg-block d-none">
                                   <span class="brand-primary-text-color">V-calling-</span>
                        Revolutionizing Your Communication Experience
                            </span>
                        <span class="d-lg-none ">
                                   <span class="brand-primary-text-color">V-calling-</span>
                        Revolutionizing Your Communication Experience
                            </span>
                    </h1>
                    <p class="my-lg-4 text-secondary f-20 justify-text">Welcome to the future of seamless
                        communication with
                        V-Calling, the latest innovation from Volmint Technologies. Designed to redefine the way you
                        connect, V-Calling is your all-in-one solution for crystal-clear voice calls,
                        integrating cutting-edge technology with user-friendly features. Whether you’re looking to
                        enhance team collaboration, streamline customer interactions, or simply enjoy a high-quality
                        call experience, V-Calling provides unmatched reliability and performance.
                    </p>
                    <button class="brand-primary-text-color py-2 bg-white border px-5 rounded-0 fw-bold border-0 shadow-lg hover-effect"
                            (click)="openModal()">Take a Free Demo <i
                        class="ms-3 fa-solid fa-arrow-right"></i>
                    </button>
                    <ng-template #contactFormModal>
                        <app-contact-form [isModalOpen]="isModalOpen" (closeModal)="closeModal()"></app-contact-form>
                    </ng-template>
                    <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                        <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 align-self-center">
                <div class="card lg:mr-0 overflow-hidden position-relative">
                    <img src="assets/img/landing-new/thumbnail/volmint-thumbnail.jpg"
                         class="img-fluid " alt="University Management Softwarer Image" id="video-thumbnail">
                    <button class="play-button position-absolute" (click)="playVideo()"></button>
                    <video #videoElement class="d-none " controls>
                        <source src="assets/img/landing-new/vcalling/vcalling.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                    <!--                    <video src="assets/img/landing-new/vcalling/vcalling.mp4" (pause)="true" loop></video>-->
                    <!--                    <img src="assets/img/landing-new/vcalling/vcalling3.png" alt="VoIP Phone System" class="img-fluid"/>-->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid mt-5 pt-lg-5">
    <div class="container">
        <div class="row g-2">
            <div class="col-lg-3 col-md-6  col-12" *ngFor="let item of switch">
                <div class="card h-100 border-0 image-container shadow" style="">
                    <img src="{{item.image}}" class="card-img-top" alt="VoIP Phone System">
                    <div class="card-body">
                        <p class="fs-6 card-title fw-bold text-center">{{ item.title }}</p>
                        <p class="card-text text-secondary text-wrap justify-text">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-5">
    <div class="container py-lg-4">
        <div class="row g-lg-5">
            <div class="col-12 col-lg-6 d-flex align-items-center">
                <img src="assets/img/landing-new/vcalling/vcalling3.1.jpg" alt="VoIP Phone System" class="img-fluid"/>
            </div>
            <div class="col-12 col-lg-6 mt-lg-5">
                <h2 class="fs-1 fw-bolder mb-4 ">
                    Get Started with V-Calling in
                    <span class="brand-primary-text-color">4 Easy Steps</span>
                </h2>
                <div class="row g-4">
                    <div
                        class="col-12 px-2 col-md-6 col-lg-12 step-card border-0 py-2 d-flex align-items-center shadow-sm"
                        *ngFor="let item of steps">
                        <span class="step-icon-container shadow me-3">
                            <i [ngClass]="item.image" class="step-icon brand-primary-text-color"></i>
                        </span>
                        <div>
                            <h3 class="fs-5 fw-bold mb-2 text-secondary">
                                {{ item.heading }}
                            </h3>
                            <p class="text-secondary text-wrap  mb-0">
                                {{ item.description }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-5 pt-lg-5">
    <div class="container brand-primary-bg pt-5 p-lg-5 border-0 shadow-lg">
        <div class="row mt-lg-5 ">
            <div class="col-lg-6 col-12 text-md-center text-lg-start">
                <h2 class="fs-1 color-white fw-bold">Sign up now!</h2>
                <p class="color-white fw-bold justify-text">Experience V-Calling with no upfront commitment—sign up
                    now
                    for a free trial and explore our features risk-free.
                </p>
                <p class="color-white my-4 fs-6 fw-bold" (click)="goTo('/contact')"><u>Start Trial <i
                    class="fas fa-arrow-right"></i></u></p>
            </div>
            <div class="col-lg-6 col-12 position-relative  d-none d-lg-block">
                <div class="image-position">
                    <img src="assets/img/landing-new/vcalling/girl.png" alt="VoIP Phone System" class="img-fluid"/>
                </div>
            </div>
            <div class="col-lg-6 col-12 d-block d-lg-none text-center">
                <img src="assets/img/landing-new/vcalling/girl.png" alt="VoIP Phone System" class="img-fluid"/>
            </div>
        </div>
    </div>
</div>
<section class="solutions">
    <div class="container-fluid mt-4 pt-lg-5">
        <div class="container">
            <h2 class="fs-1 fw-bolder text-center">Transform Your Lead Management and Support
                <span class="brand-primary-text-color"> with V-Calling</span>
            </h2>
            <div class="row button-row my-lg-4 ">
                <div *ngFor="let button of buttons" class=" col-3  py-0 button-container"
                     (click)="changeDesign(button.key)">
                    <div class="row flex-grow-1">
                        <div class="col-9 text-start">
                            <button class="fw-bold rounded-3 btn-border btn-hover p-2 ">{{ button.label }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-5 d-flex justify-content-center align-items-center" *ngFor="let item of currentDesign; let i = index">
                <div class="col-lg-6 col-12 pt-2">
                    <img src="{{item.image}}" alt="VoIP Phone System" class="img-fluid rounded-4"/>
                </div>
                <div class="col-lg-6 col-12   ">
                    <div class="shadow rounded p-4 ">
                        <div class="  ">
                            <p class=" text-secondary mt-lg-4 justify-text">{{ item.description }}</p>
                        </div>
                        <button  class="border-0 bg-primary text-white mt-5 p-2 shadow px-4 fw-bold hover-effect" (click)="goTo('/contact')">Learn
                            more <i class="fa fa-arrow-right"></i>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<div class="container-fluid mt-5 " style="background: #f1f3f5">
    <div class="container">
        <div class="row ">
            <div class="col-lg-6  col-12 bg-integrate px-lg-5 py-3">
                <div class="d-flex justify-content-md-center justify-content-lg-start">
                    <img src="assets/img/project/project-logo/v-calling.png" alt="VoIP Phone System"
                         class="img-fluid h-25 w-25 d-none d-lg-block"/>
                    <img src="assets/img/project/project-logo/v-calling.png" alt="VoIP Phone System"
                         class="img-fluid  w-50 d-lg-none"/>
                </div>
                <h2 class="fs-3 fw-bold  justify-text">Seamlessly Integrate V-Calling with Your CRM and Ticketing
                    Systems</h2>
                <p class="text-secondary">Streamline your communication with V-Calling by integrating it with your CRM and ticketing systems.
                    Simplify customer interactions, track conversations, and resolve queries faster—all in one place.
                    This seamless integration ensures smoother workflows, enhanced productivity, and improved customer
                    satisfaction. Whether managing leads or resolving support tickets, V-Calling empowers your team to
                    deliver exceptional results with ease. Transform your communication process today!</p>
            </div>
            <div class="col-lg-6 col-12 d-flex py-3 py-lg-5 justify-content-center align-items-center">
                <img src="assets/img/landing-new/vcalling/vcalling10.jpg" alt="VoIP Phone System"
                     class="img-fluid shadow rounded"/>
            </div>
        </div>
    </div>
</div>
<section class="testimonial">
    <div class="container-fluid mt-5 pt-lg-5">
        <h2 class="fs-1 fw-bolder text-center">Testimonials From Our Satisfied Customers</h2>
        <div class="container brand-primary-bg mt-4 p-4 shadow-lg border-0">
            <div class="row">
                <div class="col-lg-6 col-12 text-center">
                    <img src="assets/img/landing-new/vcalling/vcalling11.png" alt="VoIP Phone System"
                         class="img-fluid w-50"/>
                </div>
                <div class="col-lg-6 col-12 mt-lg-5">
                    <div id="testimonialCarousel" class="carousel slide" data-bs-ride="carousel"
                         data-bs-interval="3000">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="stars ">
                                    <div class="col-lg-4 col-12 text-center">
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                    </div>
                                </div>
                                <p class="text-center text-lg-start color-white mt-4 justify-text">V-Calling has transformed our customer
                                    support
                                    experience! The Cloud Contact Center integration makes managing inquiries from
                                    multiple channels effortless, and the performance analytics help us continually
                                    improve. Highly recommended!
                                </p>
                                <p class="text-center text-lg-start mt-4 color-white fs-6">Chethan K.</p>
                                <p class="text-center text-lg-start color-white fs-6">CEO</p>
                            </div>

                            <div class="carousel-item">
                                <div class="stars ">
                                    <div class="col-lg-4 col-12 text-center">
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                    </div>
                                </div>
                                <p class=" color-white mt-4 text-center text-lg-start justify-text">We’ve seen a significant boost in our
                                    sales
                                    productivity thanks to the Auto Sales Dialer. The seamless integration with our CRM
                                    has streamlined our outreach process, making it easier to hit our targets.
                                </p>
                                <p class="mt-4 text-center text-lg-start color-white fs-6">Ashutosh P.</p>
                                <p class="color-white fs-6 text-center text-lg-start">Customer Relations Manager</p>
                            </div>

                            <div class="carousel-item">
                                <div class="stars">
                                    <div class="col-lg-4 col-12 text-center">
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                        <img src="assets/img/landing-new/vcalling/vcalling-star.webp"
                                             alt="VoIP Phone System"
                                             class="img-fluid"/>
                                    </div>
                                </div>
                                <p class=" color-white mt-4 text-center text-lg-start justify-text">The Conversational AI feature is
                                    impressive! It
                                    handles customer queries with human-like interaction, freeing up our team to focus
                                    on more complex issues. V-Calling’s intuitive interface and reliability make it a
                                    top choice for our business.
                                </p>
                                <p class="mt-4 text-center text-lg-start color-white fs-6">Karthik R.</p>
                                <p class="color-white text-center text-lg-start fs-6">Director</p>
                            </div>
                        </div>
                        <div class="d-none d-lg-block">
                            <button class="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel"
                                    data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#testimonialCarousel"
                                    data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="container-fluid mt-5 pt-lg-4">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-5">
                <div class="">
                    <img src="assets/img/landing-new/contact-us/faq.png" alt="Admission Management System"
                         class="img-fluid d-none d-lg-block"/>
                    <h2 class="fw-bold text-center mt-lg-4 mt-lg-0 fs-2 text-lg-start text-secondary">Frequently Asked Questions</h2>
                    <p class="text-secondary d-none d-lg-block">Have a question that is not answered? You can contact us at</p>
                    <p class="brand-primary-text-color d-none d-lg-block fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                                            class="text-decoration-underline brand-primary-text-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="d-none d-lg-block brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>

            <div class="col-12 col-lg-7 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class=" fw-bold" style="color: #6752A9;">  <div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; How does V-Calling improve my team’s communication?</span>
                            </button>
                        </h3>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body  text-secondary justify-text">
                                V-Calling enhances team communication by offering crystal-clear voice and audio calls,
                                easy integration with CRM systems, and a user-friendly interface. Its advanced features,
                                like the VoIP Phone System and Cloud Contact Center, ensure seamless connectivity and
                                efficient collaboration.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class=" fw-bold" style="color: #6752A9;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp;Can I try V-Calling before committing?</span>
                            </button>
                        </h3>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body  text-secondary justify-text">
                                Yes! We offer a free trial of V-Calling so you can explore its features and see how it
                                fits your needs without any upfront cost. Sign up now to start your risk-free trial!
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class=" fw-bold" style="color: #6752A9;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp;How do I integrate V-Calling with my existing CRM and ticketing systems?</span>
                            </button>
                        </h3>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body  text-secondary justify-text">
                                Integrating V-Calling with your CRM and ticketing tools is straightforward. Our system
                                supports seamless integration, allowing you to synchronize contacts and streamline
                                workflows effortlessly.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class=" fw-bold" style="color: #6752A9;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div>  &nbsp;What types of businesses can benefit from V-Calling?</span>
                            </button>
                        </h3>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body text-secondary justify-text">
                                V-Calling is designed to support a wide range of businesses and sectors. Whether you’re
                                in sales, or customer support, or need cloud telephony solutions, V-Calling offers
                                tailored features like the Auto Sales Dialer and Conversational AI to enhance your
                                operations.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class=" fw-bold" style="color: #6752A9;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp;How do I track and optimize my communication performance with V-Calling?</span>
                            </button>
                        </h3>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body text-secondary justify-text">
                                V-Calling provides comprehensive analytics tools that help you monitor call performance
                                and user engagement. Use these insights to make data-driven decisions and continuously
                                improve your communication strategies.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid mt-5 ums-bottom-bg ps-lg-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-lg-6 col-12">
                <h2 class="fw-bolder d-none d-lg-block   color-blue">
                    Trusted by Leading Businesses – Enhance Communication & Boost Efficiency!
                </h2>

            </div>
            <div class="col-lg-6 col-12 text-center">
                      <span class="fs-4 fw-bold  text-white">Fill out the form, and we’ll be in touch soon!
                </span>
                <div class="bg-light-pink shadow py-5 px-4 mt-2">
                    <form [formGroup]="contactForm" class="">
                        <div class="mb-4 d-sm-flex g-3 mx">
                            <input type="name" class="form-control bg-white rounded-3 text-secondary me-sm-1 py-3"
                                   id="name"
                                   formControlName="name"
                                   placeholder="Enter Your Name" required>
                            <small *ngIf="submitted && contactForm.get('name').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                            <input type="email" class="mt-3 mt-md-0 form-control bg-white rounded-3 text-secondary py-3"
                                   id="email" formControlName="email"
                                   placeholder="Enter Your Email" required>
                            <small *ngIf="submitted && contactForm.get('email').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="mb-4">

                        </div>
                        <div class="mb-4">
                            <input type="tel" class="form-control bg-white rounded-3 text-secondary py-3"
                                   id="contact" formControlName="contact"
                                   placeholder="Enter Your Phone No." required>
                            <small *ngIf="submitted && contactForm.get('contact').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="mb-4">
                                <textarea class="form-control rounded-3 bg-white text-secondary" id="message"
                                          formControlName="message"
                                          rows="4" style="resize: none;"
                                          placeholder="Your Message" required></textarea>
                            <small *ngIf="submitted && contactForm.get('message').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="text-center mt-4">
                            <button type="submit"
                                    class="bg-color-blue border-0  color-white px-5 py-2 w-50 fs-6 fw-bold hover-effect"
                                    (click)="submit()">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
